"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShareValue = useShareValue;
exports.useDeleteSharedValue = useDeleteSharedValue;
exports.useSelectSharedValue = useSelectSharedValue;
const react_1 = require("react");
const effector_react_1 = require("effector-react");
function useShareValue() {
    const SharedHostGateway = window.sharedHostGateway;
    return (0, react_1.useMemo)(() => (path, sharedValue) => {
        if (!SharedHostGateway) {
            throw new Error('SharedHostGateway not found, state sharing is impossible');
        }
        if (!path || !Array.isArray(path) || !path.length) {
            throw new Error('Wrong path to shared key in `useShareValue. `path` should be non empty array of strings `path: string[]`');
        }
        if (!SharedHostGateway.stateSharing) {
            throw new Error('SharedHostGateway: state sharing was not started');
        }
        SharedHostGateway.stateSharing.shareValue({
            storePath: path,
            sharedValue
        });
    }, []);
}
function useDeleteSharedValue() {
    const SharedHostGateway = window.sharedHostGateway;
    return (0, react_1.useMemo)(() => (path) => {
        if (!SharedHostGateway) {
            throw new Error('SharedHostGateway not found, state sharing is impossible');
        }
        if (!path || !Array.isArray(path) || !path.length) {
            throw new Error('Wrong path to shared key in `useDeleteShareValue. `path` should be non empty array of strings `path: string[]`');
        }
        if (!SharedHostGateway.stateSharing) {
            throw new Error('SharedHostGateway: state sharing was not started');
        }
        SharedHostGateway.stateSharing.deleteSharedValue(path);
    }, []);
}
function fallbackComparator(a, b) {
    return a !== b;
}
function useSelectSharedValue(fn, comparator = fallbackComparator) {
    const SharedHostGateway = window.sharedHostGateway;
    if (!SharedHostGateway) {
        throw new Error('SharedHostGateway not found, state sharing is impossible');
    }
    if (!SharedHostGateway.stateSharing) {
        throw new Error('SharedHostGateway: state sharing was not started');
    }
    const store = SharedHostGateway.stateSharing.$sharedState;
    // TODO - using of deeply nested store structure is not idiomatic for effector,
    // Solution here is to preserve path-based sharing behaviour.
    // We might consider creating on-demand stores using path as access "key" in the future
    const result = (0, effector_react_1.useStoreMap)({
        store,
        fn,
        keys: [fn, comparator],
        updateFilter: comparator
    });
    return result;
}
